import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from '@core/services';
import { AuthService } from '@pages/auth/services/auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ServerMessage } from '../../@shared/models';
import { ToasterService } from '../services/toaster.service';
import { AppLoaderService } from './../../@shared/services/app-loader.service';
import { SKIP_ERROR_TOAST, SKIP_LOADER } from './http-context.tokens';
@Injectable({ providedIn: 'root' })
export class ServerErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly authService: AuthService,
    private readonly commonService: CommonService,
    private readonly toasterService: ToasterService,
    private readonly appLoaderService: AppLoaderService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Background requests (SKIP_LOADER) never touch the loader, so they cannot hide it early for another call either.
    const background = request.context.get(SKIP_LOADER);
    if (!background) {
      this.commonService.isApiCallInProgress$.next(true);
    }
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && !background) {
          this.commonService.isApiCallInProgress$.next(false);
          this.appLoaderService.toggleLoader(false);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (!background) {
          this.commonService.isApiCallInProgress$.next(false);
        }
        const errorResponse: ServerMessage | null | undefined = error.error;
        if (!request.context.get(SKIP_ERROR_TOAST)) {
          // Status 0 means the request never reached the server (no signal, DNS, CORS), so there is
          // no server message to show.
          this.toasterService.error(
            error.status === 0 ? 'Connection problem. Check your signal and try again.' : errorResponse?.message || 'Something went wrong. Please try again.',
          );
        }
        if (!background) {
          this.appLoaderService.toggleLoader(false);
        }

        if ([401].includes(error.status)) {
          this.authService.logOut();
          return throwError(() => error);
        } else if (error.status === 500) {
          console.error(error);
          return throwError(() => error);
        } else {
          return throwError(() => error);
        }
      }),
    );
  }
}
